var currentTextIndex = 0;

function addText()
{
    var editIcon = $('.edit-icon').attr('src');
    var group = draw.group();
    var edit = group.image(editIcon, 16, 16).fill('#000000').x(-20).y(-20);
    var text = group.text(defaultText).fill('#000000').font({
        size: startFontSize,
    });
    text.elementIndex = index;

    var timer = null;
    $(text.node).hover(function() {
        $(edit.node).show();
        clearTimeout(timer);
    }, function() {
        timer = setTimeout(function() {
            $(edit.node).hide();
        }, 1000);
    });

    $(edit.node).hover(function() {
        clearTimeout(timer);
        $(edit.node).show();
    }, function() {
        timer = setTimeout(function() {
            $(edit.node).hide();
        }, 1000);
    });

    text.dblclick(function() {
        editText(text);
    });

    edit.click(function() {
        editText(text);
    });

    centerElement(text);
    setEvents(text);
    text.resize();
    setSelectOnClick(text);
    elements.push(text);
    addTextMenu(text);

    $(text.node).parent().find('image').attr('x', text.x() - 10);
    $(text.node).parent().find('image').attr('y', text.y() - 10);
}

function saveText(index, e) {
    var value = $(e).prev().val();
    elements[index].text(value);
    $.fancybox.close();
}

function editText(e)
{
    e.selectize(false);
    currentTextIndex = e.elementIndex;
    $.fancybox('<div class="edit-text"><textarea style="height:200px;">' + e.text() + '</textarea><button onclick="saveText(currentTextIndex, this);">Opslaan</button></div>', {
        helpers: {
            overlay: {
                locked: false
            }
        }
    });
}

function addTextMenu(element)
{
    var $menu = $($('.markup-text').html());
    var $parent = $menu.closest('.text-plaatsen-container');

    $parent.attr('data-index', index++);
    $('.text-blok .afbeelding-plaatsen-container').last().before($menu);

    setColorPicker($menu, element);
    setFontSelector($menu, element);
    setEditTextEvent($menu, element);

    setMenuTekst($menu.find('.afbeelding-plaatsen-titel'), defaultText);
}

function setColorPicker($menu, element)
{
    var $colorpicker = $menu.find('.colorpicker-init');
    var color = '000000'
    $colorpicker.find('div').css('backgroundColor', '#' + color);
    $colorpicker.ColorPicker({
        color: color,
        onChange: function (hsb, hex, rgb) {
            element.fill('#' + hex);
            $colorpicker.find('div').css('backgroundColor', '#' + hex);
        }
    });
}

function setFontSizePercentage($menu, fontSize)
{
    var $procent = $menu.find('.formaat-slider-procent');
    var one = maxFontSize / 100;
    var procent = Math.floor(fontSize / one);
    $procent.text(((procent > 0) ? procent : '1') + '%');
}

function setFontSelector($menu, element)
{
    var $fonts = $menu.find('.lettertype-font-selectie').first();

    setFontSizePercentage($menu, startFontSize);

    $menu.find('.formaat-slider').slider({
        max: maxFontSize,
        step: 1,
        value: startFontSize,
        animate: "slow",
        min: 1,
        slide: function( event, ui ) {
            var fontSize = ui.value;

            setFontSizePercentage($menu, fontSize);

            element.font({
                size: fontSize,
            });
        }
    });

    $fonts.fontSelector({
        'hide_fallbacks' : true,
        'initial' : 'Arial,Arial,Helvetica,sans-serif',
        'selected' : function(style) {
            element.font({
                family: style,
            });
        },
        'fonts' : [
            'Arial,Arial,Helvetica,sans-serif',
            'Arial Black,Arial Black,Gadget,sans-serif',
            'Comic Sans MS,Comic Sans MS,cursive',
            'Courier New,Courier New,Courier,monospace',
            'Georgia,Georgia,serif',
            'Impact,Charcoal,sans-serif',
            'Lucida Console,Monaco,monospace',
            'Lucida Sans Unicode,Lucida Grande,sans-serif',
            'Palatino Linotype,Book Antiqua,Palatino,serif',
            'Tahoma,Geneva,sans-serif',
            'Times New Roman,Times,serif',
            'Trebuchet MS,Helvetica,sans-serif',
            'Verdana,Geneva,sans-serif',
            'Gill Sans,Geneva,sans-serif'
        ]
    });
}

function setEditTextEvent($menu, element)
{
    $menu.find('.text-title').on('click', function() {
        if($menu.find('.edit-text').length !== 0) return false;
        var $div = $('<div>').addClass('edit-text');

        var $textarea = $('<textarea>').text(element.text());
        var $btn = $('<button>').text('Opslaan').click(function() {
            element.text($textarea.val());
            $div.remove();
            setMenuTekst($menu.find('.afbeelding-plaatsen-titel'), value);
        });
        $div.append($textarea);
        $div.append($btn);
        $menu.find('.afbeelding-plaatsen-opties').prepend($div);
        $textarea.focus();
    });
}


function setMenuTekst($titel, text) {
    $titel.text(text.trunc(20) + '...');
}

